import React, {useState} from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from "@material-ui/core/Grid";
import makeStyles from "@material-ui/styles/makeStyles";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import { useGlobalState } from '../../../state';
import { isToday } from '../../../common/date';
import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
const useCardStyles = makeStyles(theme => ({
    card: {
        minWidth: 275,
    },
    cardActionsContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    gridMargin:{
        marginBottom: theme.spacing(3),
        marginRight: theme.spacing(2)
    }
}));

const Mobile = ({data,onDelete,onEdit,farmType}) => {
    const [{user}] = useGlobalState();
    const classes = useCardStyles();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [accessDialogOpen, setAccessDialogOpen] = useState(false);


    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = () => {
        setAnchorEl(null);
        onDelete();
    };

    const handleEdit = () => {
        setAnchorEl(null);
        onEdit();


    };

    const handleClick = event => {
        if((user.role !== "ADMIN" && user.role !== "FARMADMIN" && !isToday(data.entryDate))){
            setAccessDialogOpen(true);
            return;
        }
        setAnchorEl(event.currentTarget);
    };

    return <Grid item>
        <Card className={classes.card}>
            <CardHeader
                action={
                    <IconButton aria-label="settings" 
                    // disabled={(user.role !== "ADMIN" && !isToday(data.entryDate))} 
                    onClick={handleClick}>
                        <MoreVertIcon/>
                    </IconButton>
                }
                title={`Shed Name : ${data.shedName}`}
            />
            <CardContent>
                <Grid
                    container
                    justify='space-between'
                    alignItems='flex-end'
                >
                    <Grid class={classes.gridMargin} item>
                        <Typography variant="h5" component="h2">
                            {data.batchName}
                        </Typography>
                        <Typography color="textSecondary">
                            Batch Name
                        </Typography>   
                    </Grid>
                    <Grid class={classes.gridMargin} item>
                        <Typography variant="h5" component="h2">
                            {moment(data.entryDate).format("DD-MM-YYYY")}
                        </Typography>
                        <Typography color="textSecondary">
                            Entry Date
                        </Typography>   
                    </Grid>
                    {farmType === 2 ? (
                    <>
                    <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.mortality}
                        </Typography>
                        <Typography color="textSecondary">
                            Mortality
                        </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.feedReceived}
                        </Typography>
                        <Typography color="textSecondary">
                            Feed (Kg)
                        </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.bodyWeight}
                        </Typography>
                        <Typography color="textSecondary">
                            Avg Weight
                        </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.water}
                        </Typography>
                        <Typography color="textSecondary">
                            Water (L)
                        </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.uniformity}
                        </Typography>
                        <Typography color="textSecondary">
                            Uniformity %
                        </Typography>
                    </Grid>
                    </>
                    ) : (
                    <>
                    <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.eggClosingStock}
                        </Typography>
                        <Typography color="textSecondary">
                            Egg Closing Stock (Trays)
                        </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.mortality}
                        </Typography>
                        <Typography color="textSecondary">
                            Mortality (Nos)
                        </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.eggSales}
                        </Typography>
                        <Typography color="textSecondary">
                            Egg Sales (Trays)
                        </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.eggBreakage}
                        </Typography>
                        <Typography color="textSecondary">
                            Broken Egg (Nos)
                        </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.damagedEggs}
                        </Typography>
                        <Typography color="textSecondary">
                            Damaged Eggs (Nos)
                        </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.closingFeed}
                        </Typography>
                        <Typography color="textSecondary">
                            Closing Feed (Kg)
                        </Typography>
                    </Grid>
                    </>
                    )}
                </Grid>
            </CardContent>
        </Card>
        <Menu
            id="shed-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
        >
            <MenuItem onClick={handleEdit}>Edit</MenuItem>
            <MenuItem onClick={handleDelete}>Delete</MenuItem>
        </Menu>
        <Snackbar
            open={accessDialogOpen}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            autoHideDuration={3000}
            onClose={() => setAccessDialogOpen(false)}
            className={classes.snackbar}>
                    <Alert
                        className={classes.myAlert}
                        severity="info"
                    >
                        Please contact your Administrator to edit or delete old data
                    </Alert>
        </Snackbar>
    </Grid>
};

export default Mobile;